const model = {
    genderDetails: null,
    loading: false,
    error: null,
};

export default model;